export default __webpack_public_path__ + "static/manufacturing-workflow-4727a5136acc75cc8ff9fce5f68c297d.svg";